import { useState } from "react";
import { useGuide } from "@/lib/guide";
import { Eyebrow } from "@/components/mh/bits";
import { ModuleView } from "@/components/guide/ModuleView";
import { AskGuide } from "@/components/guide/AskGuide";

export default function Academy() {
  const { guide, done } = useGuide();
  const [id, setId] = useState("welcome");
  if (!guide) return <div className="h-[50vh] grid place-items-center font-mono text-xs text-muted-foreground">Opening the Academy…</div>;
  const m = id === "ask" ? null : guide.modules.find((x) => x.id === id);
  const pct = Math.round((done.length / guide.modules.length) * 100);
  return (
    <div className="max-w-[1300px] mx-auto space-y-6" data-testid="academy-page">
      <header className="mh-rise">
        <Eyebrow>Manahouse Academy</Eyebrow>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-3">Get the most out of <em className="text-muted-foreground">every part of the house.</em></h1>
        <div className="flex items-center gap-3 mt-4 max-w-md">
          <div className="flex-1 h-1.5 rounded-full bg-white/[0.06] overflow-hidden"><div className="h-full bg-[#D4FF3A] transition-[width] duration-700" style={{ width: `${pct}%` }} /></div>
          <span className="font-mono text-[11px] text-muted-foreground" data-testid="academy-progress">{done.length}/{guide.modules.length} learned</span>
        </div>
      </header>
      <div className="grid lg:grid-cols-[280px_1fr] gap-6">
        <nav className="space-y-4 lg:sticky lg:top-4 self-start" data-testid="academy-nav">
          {guide.tracks.map((t, ti) => (
            <div key={t.id}><div className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground mb-1">{ti + 1}. {t.title}</div>
              {guide.modules.filter((x) => x.track === t.id).map((x) => (
                <button key={x.id} onClick={() => setId(x.id)} data-testid={`academy-module-${x.id}`}
                  className={`w-full text-left text-sm rounded-lg px-3 py-2 flex items-center gap-2 transition-colors ${id === x.id ? "bg-white/[0.07]" : "hover:bg-white/[0.03] text-muted-foreground hover:text-foreground"}`}>
                  <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: done.includes(x.id) ? "#D4FF3A" : "#3A3A46" }} />{x.title}</button>
              ))}
            </div>
          ))}
          <button onClick={() => setId("ask")} data-testid="academy-ask" className={`w-full text-left text-sm rounded-lg px-3 py-2 border border-[#D4FF3A]/30 ${id === "ask" ? "bg-[#D4FF3A]/10" : ""}`}>Ask the guide →</button>
        </nav>
        <div className="rounded-2xl border border-white/[0.07] bg-white/[0.015] p-5 sm:p-8 min-h-[60vh]">
          {m ? <ModuleView key={m.id} m={m} /> : <div className="h-[60vh]"><AskGuide /></div>}
        </div>
      </div>
    </div>
  );
}
